import React from "react";

import {addNotification} from "../state/notifications_slice";

export const addWarningNotification = (message: string | React.JSX.Element, timeout?: number) =>
    addNotification({
        notification: {content: message, type: "warning"},
        timeout
    });
